module.exports = __webpack_public_path__ + "static/images/separeate.282VAGM.svg";